import { createRouter, createWebHashHistory } from 'vue-router';
import Layout from '../layouts/Layout';

export default class {
  constructor(store, base) {
    this.store = store;

    const baseURL = base || '/';
    const routes = [
      { path: '/', component: Layout },
      {
        path: '/:slug',
        component: Layout,
      },
    ];

    this.router = createRouter({
      history: createWebHashHistory(baseURL),
      routes,
    });

    this.router.beforeEach((to, from, next) => {
      if (!to.matched.length) {
        next();
      } else {
        next();
      }
    });

    return this.router;
  }
}
